<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain
      class="paddingBottomNone"
      maxwidth-container="820px"
    >
      <v-breadcrumbs
        v-if="$vuetify.breakpoint.mdAndUp"
        :items="menus"
        class="pl-0 mt-6"
      >
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :to="item.href"
            :disabled="item.disabled"
            class="body-2"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>

      <RastreioTimeline
        :compra-id="compraId"
      />
    </InternaMain>
  </Wrapper>
</template>

<script>
import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';
import RastreioTimeline from '@/components/Rastreio/RastreioTimeline.vue';

export default {
  name: 'AcompanharEnvio',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    RastreioTimeline,
  },

  props: {
    compraId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    menus() {
      return [
        {
          text: 'Minhas Compras',
          disabled: false,
          href: '/minhas-compras/',
        },
        {
          text: 'Detalhe da compra',
          disabled: false,
          href: `/minhas-compras/detalhe-compra/${this.compraId}`,
        },
        {
          text: 'Acompanhar envio',
          disabled: true,
        },
      ];
    },
  },
};
</script>

<style lang="scss">
  .paddingBottomNone{
    padding-bottom: 0!important
  }
</style>
